import React from "react";
import cx from "classnames";

const TabBar = ({ tabs, activeTabId, setActiveTab }) => {
  return (
    <div className="bcn_tabs__bar">
      {tabs.map((t) => {
        return (
          <div
            key={t.id}
            className={cx("bcn_tabs__item", { "bcn_tabs__item--active": t.id == activeTabId })}
            onClick={() => setActiveTab(t.id)}
          >
            {t.label}
            {t.icon}
          </div>
        );
      })}
    </div>
  );
};

export default TabBar;
